import {Layout} from '@sdox/ui'

import {DocumentContainerSkeleton} from './DocumentSkeleton'
import {FeedSkeleton} from './FeedSkeleton'

export const FolderSkeleton = () => (
  <div className={'flex h-screen'}>
    <Layout.Aside className={'right-0 md:right-full'}>
      <FeedSkeleton />
    </Layout.Aside>
    <Layout.Main className={'h-max overflow-hidden md:ml-sidebar'}>
      <DocumentContainerSkeleton />
    </Layout.Main>
  </div>
)
